// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Container, Grid, Image } from 'semantic-ui-react'
import sign from '../assets/sign.png'

export default class About extends Component {
  render () {
    return (
      <Container className='masterdiv'>
        <div className='slavediv'>
          <Grid stackable verticalAlign='middle'>
            <Grid.Column width='3' />
            <Grid.Column width='10'>
              <h1 className='mb'>About</h1>
              <p style={{ fontWeight: '900', fontSize: '1.5em' }}>
                Our mission is to be the best cross-platform development solution for SMEs and
                potentially large companies, build a relationship with you that is long-lasting,
                mutually beneficial and optimized to reduce time to market.
              </p>
              <p style={{ fontWeight: '300', fontSize: 16 }} className='mt'>
                Our core values are <i>good vibes</i>, achieving technological <i>excellence</i> and
                operating with the highest standards of <i>integrity</i>.
              </p>
              <Image src={sign} style={{ width: 100 }} />
            </Grid.Column>
            <Grid.Column width='3' />
          </Grid>
        </div>
      </Container>
    )
  }
}
